<template>
  <section class="contact" id="contact">
            <div class="title-container">
                <h2 class="title">Kontakt</h2>
                <h3 class="description">Skontaktuj się!</h3>
            </div>
            <div class="content-container">
              <div class="info-container">
                  <div class="box hidden info-one">
                          <img src="@/assets/locate.png" alt="">
                          <div class="text-info">
                          <h4>Lokalizacja</h4>
                            <p>Poznań, Polska</p>
                          </div>
                  </div>
                  <div class="box hidden info-two">
                            <img src="@/assets/mail.png" alt="">
                          <div class="text-info">
                                <h4>Mail</h4>
                          <a href="mailto:olivier.smialkowski@gmail.com"> olivier.smialkowski@gmail.com</a>
                  </div>
                  </div>
                  <div class="box socials hidden info-three">
                            <img src="@/assets/find.png" alt="">
                            <div class="text-info">
                              <h4>Więcej:</h4>
                              <a href="https://www.linkedin.com/in/olivier-%C5%9Bmia%C5%82kowski-830a63204/" target="_blank"> <img class="social-icon" alt="Ikona LinkedIn'a" src="https://i.imgur.com/ae1v1jj.png"></a> 
                              <a href="https://github.com/Olivieer77" target="_blank"> <img class="social-icon" alt="Ikona GitHuba" src="https://i.imgur.com/L1d3OUy.png"></a> 
                            </div>
                  </div>
              </div>
               <div class="contactForm">
                <form @submit.prevent="handleSubmit">
                  <div class="input-box hidden info-one">
                    <!-- jak formularz bedzie dzialac to przywrocic te wyzsze -->
                      <!-- <input type="text" name="name" placeholder=" " minlength="3" required="required" v-model="name"> -->
                      <input type="text" name="name" placeholder=" " v-model="name">
                      <label for="">Imię</label>
                  </div>
                  <div class="input-box hidden info-two">
                          <!-- <input type="email" name="email" placeholder=" " required="required" v-model="email"> -->
                          <input type="email" name="email" placeholder=" " >
                          <label for="">Email</label>
                      </div>
                      <div class="input-box hidden info-three">
                          <!-- <input type="text" name="topic" placeholder=" " minlength="3" required="required" v-model="title"> -->
                          <input type="text" name="topic" placeholder=" " >
                          <label for="">Temat wiadomości</label>
                      </div>
                      <div class="input-box hidden info-four">
                          <!-- <textarea name="message" placeholder=" " minlength="3" required="required" v-model="message"></textarea> -->
                          <textarea name="message" placeholder=" " v-model="message"></textarea>
                          <label for="">Wpisz swoją wiadomość...</label>
                      </div>
                      <div class="btn hidden info-five">
                        <!-- <button @click="isShow == true">Wyślij wiadomość</button> -->
                        <button class="send">Wyślij wiadomość</button>
                      </div>
                      <!-- <div class="modal" v-show="isShow"> <button @click="isShow == false">zamknij</button></div> -->
                </form>
                      <!-- <button @click="showModal">test</button> -->
                     
                      <div class="modal"><img class="close" src="@/assets/close.png"><p>Na ten moment formularz kontaktowy nie działa, bardzo prosze o kontakt na mail: <a href="mailto:olivier.smialkowski@gmail.com"> olivier.smialkowski@gmail.com</a></p></div>
              </div>
            </div> 
    </section>
</template>

<script>
// import { projectFirestore } from '../firebase/config'


export default {
    name: "Contact",
    data(){
        return {
          isShow: false,
        }
      },
      methods: {
         showModal () {
          this.isShow = true;
          // console.log(this.isShow);
        },

          closeModal () {
          this.isShow = false;
          // console.log(this.isShow);
        }
      },
     mounted() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('show');
        }
      })
    });

    const hiddenElements = document.querySelectorAll('.hidden');
    hiddenElements.forEach((el) => observer.observe(el));

    const send = document.querySelector('.send')
    const close = document.querySelector('.close')
    const modal = document.querySelector('.modal')

    send.addEventListener('click', () =>  {
      // modal.style.display = 'block'
      modal.classList.add('active')
    })

    close.addEventListener('click', () =>  {
      // modal.style.display = 'none'
      modal.classList.remove('active')
    })
  }
}
</script>

<style lang="scss" scoped>

  .hidden {
    opacity: 0;
    // filter: blur(5px);
    transition: all 1.5s;
    @media(prefers-reduced-motion) {
      transition: none;
    }
  }

  .hidden.info-one {
    transition: all 1.5s 0.1s ;
  }

  .hidden.info-two {
      transition: all 1.5s 0.2s ;
  }

  .hidden.info-three {
      transition: all 1.5s 0.3s ;
  }

    .hidden.info-four {
      transition: all 1.5s 0.4s ;
  }

    .hidden.info-five {
      transition: all 1.5s 0.5s ;
  }

    .show {
    opacity: 1;
    // filter: blur(0);
  }

// test
  

#contact {
  position: relative;
  padding: 2rem 0 0;
   opacity: 1;
   margin-bottom: -5rem;

   @media(max-width: 1024px) {
      margin-bottom: -4rem;
   }
    @media(max-width: 768px) {
      margin-bottom: 0;
   }

   @media(max-width: 425px) {
      margin-bottom: 1.5rem;
   }

        }
        
.content-container {
  display: flex;
  justify-content: center;

.info-container {
  padding: 5rem 0;
  margin-right: 2rem;

  .info-one {
    display: flex;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 10px;
      margin-bottom: 5px;
    }
  }

   .info-two {
    display: flex;
    align-items: center;
    img {
      width: 32px;
      height: 32px;
      margin-right: 12px;
      margin-bottom: 3px;
    }
    a {
      color: #000;
      text-decoration: none;
    }
  }

  .info-three {
     margin-bottom: 0.1rem;
     display: flex;
     align-items: center;

     img {
      width: 32px;
      height: 32px;
      margin-right: 10px;
      // margin-bottom: 55px;
    }
    h4 {
      margin-left: 0px;
      margin-bottom: 0.2rem;
    }

  .social-icon {
        width: 28px;
        height: 28px;
        margin: 0 4px 0 0;
        background-color: transparent;
        transition: .3s;
  }
        a {
          margin-left: 2px;
        }
    // a:last-child{
    //   margin-left: 8px;
    // }
          a:hover {
                background-color: #fff;
                opacity: 0.6;
              }

        .social-icon {
          margin: 0 4px 0 7px;
        }
        .social-icon:nth-child(1) {
          margin: 0 7px 0 0px;
        }
  }


  .box {
    padding: 0.5rem 0;
  }

      .icons-container {
            
              .icon-box{
                display: flex;
                align-items: center;
                padding: 0.1rem 0;
                span {
                  padding: 0 0.25rem 0 0;
                  margin: 0 0 0.35rem 0;
                }
               .text {
                 align-items: center;
                 display: flex;
                 align-content: center;
               }
                a {
                  color: #000;
                  text-decoration: none;
                }
              }
      }

    }
}


.content-container {
.contactForm {
  position: relative;
  padding: 3rem;
  width: 35%;
    form {
      width: 100%;
        .input-box {
            position: relative;
            input, textarea {
              background: transparent;
              border: 1px solid #e1e1e1;
              font-family: 'Work Sans', sans-serif;
              height: 47px;
              margin-bottom: 15px;
              outline: none;
              padding: 0 15px;
              position: relative;
              width: 100%;
              z-index: 1;
              outline: none;
              resize: none;
              -webkit-transition: border-color 0.35s ease-in-out;
              -o-transition: border-color 0.35s ease-in-out;
              transition: border-color 0.35s ease-in-out;
            }

            textarea {
              height: 76px;
              padding-top: 10px;
            }

              label {
                background: #fff;
                // background: #f6f6f6;
                position: absolute;
                padding: 0 10px;
                left: 5px;
                line-height: 21px;
                color: #000;
                opacity: 0.6;
                z-index: 0;
                -webkit-transform: translateY(15px);
                -ms-transform: translateY(15px);
                transform: translateY(15px);
                -webkit-transition: transform 0.2s ease-in-out,opacity 0.3s ease-in-out;
                -o-transition: transform 0.2s ease-in-out,opacity 0.3s ease-in-out;
                transition: transform 0.2s ease-in-out,opacity 0.3s ease-in-out;
              }

              input:not(:placeholder-shown), textarea:not(:placeholder-shown):valid {
                border-color: #46A334;
            }
              input:not(:placeholder-shown):invalid, textarea:not(:placeholder-shown):invalid {
                border-color: red;
              }

              input:focus+label, input:not(:placeholder-shown)+label, textarea:focus+label, textarea:not(:placeholder-shown)+label {
                  opacity: 1;
                  transform-origin: top left;
                  z-index: 2;
                  -webkit-transform: translateY(-6px) scale(0.75);
                  -ms-transform: translateY(-6px) scale(0.75);
                  transform: translateY(-6px) scale(0.75);
              }

              input:focus, textarea:focus {
                  border-color: #2f6fb2;
              }   
        }

        // .btn {
        //   // input {
        //   //   border: none;
        //   //   background-color: green;
        //   //   padding: 0.3rem 0.6rem;
        //   //   font-size: 1.05rem;
        //   //   color: #fff;
        //   //   border-radius: 0.2rem;
        //   //   cursor: pointer;
        //   //   transition: .25s;
        //   // }
        //   // input:hover {
        //   //   background-color: lightgreen;
        //   // }
        //   input {
        //     border: 2px solid tomato;
        //     background:none;
        //     color: tomato;
        //     padding: 20px 40px;
        //     font-size: 25px;
        //     text-transform:capitalize;
        //     cursor: pointer;
        //     transition: all 0.5s;
        //     position: relative;
        //     color: tomato;
        //     overflow: hidden;
        //   }
        //   input:hover {
        //     color: white;
        //   }
        //   input:before {
        //     content: "";
        //     position: absolute;
        //     top: 0;
        //     left: 0;
        //     width: 100%;
        //     height: 100%;
        //     background: tomato;
        //     z-index: -1;
        //     border-radius:0 0 50% 50% ;
        //     height: 0%;
        //     transition: all 0.5s;
        //   }

        //   input:hover:before {
        //       height: 190%;
        //     }
        // }
        .btn {
          button {
            border: 2px solid #ff8906;
            background:none;
            padding: 0.45rem 0.6rem;
            font-size: 1rem;
            text-transform:capitalize;
            cursor: pointer;
            transition: all 0.5s;
            position: relative;
            color: #ff8906;
            overflow: hidden;
          }
          button:hover {
            color: white;
          }
          button:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #ff8906;
            // #57A4FF
            z-index: -1;
            border-radius:0 0 50% 50% ;
            height: 0%;
            transition: all 0.5s;
          }

          button:hover:before {
              height: 190%;
            }
        }
    }

                   .modal {
          display: none;
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          z-index: 999;   
          opacity: 1;
          width: 400px;
          padding: 1.5rem;
          border-radius: 0.9rem;
          // background: rgba(29, 38, 113, 1);
          border: 2px solid #ff8906; 
          color: #000;
          font-size: 1.15rem;
          text-align: center;
          margin-top: 2rem;

          a {
            color: #000;
            text-decoration: underline;
          }
  

          .close {
            position: absolute;
            top: 7%;
          right: 3%;
            width: 16px;
            height: 16px;
            cursor: pointer;
          }

        }

        .modal.active {
          display: block;
        }
       
}
}

@media (min-width: 2250px) {
  #contact {
    padding: 3rem 0 0;
    margin-bottom: -7rem;
  }


  .content-container .contactForm form .input-box input {
    height: 54px;
    font-size: 1.05rem;
  }

  .content-container .contactForm form .input-box label {
    top: 3px;
    font-size: 1.05rem;
  }

  .content-container .contactForm form .input-box textarea {
    height: 90px;
  }

  .content-container .contactForm form .btn button {
      padding: 0.5rem 0.7rem;
      font-size: 1.1rem;
  }

    .social-icon {
        width: 34px;
        height: 34px;
  }

  .content-container .info-container .info-three .social-icon {
    margin: 6px 0 7px;
  }

    .content-container .info-container .info-three .social-icon:last-child() {
      margin: 6px 0 10px;
    }

}

@media (max-width: 1024px) {
  .content-container .contactForm {
    width: 44%;
  }

  .content-container .info-container {
    padding: 3rem 0;
  }
  
  .content-container .contactForm {
    padding: 2rem 3rem 3.5rem;
  }
}

@media (max-width: 768px) {
  .title-container {
    padding-bottom: 0;
  }

  .content-container .contactForm {
    width: 48%;
  }

   .content-container .info-container {
    padding: 3.5rem 0;
  }

  .content-container .contactForm {
        padding: 3rem 0 0 1rem;
  }

  .content-container .contactForm .modal {
        padding: 1rem;
        width: 360px;
        font-size: 1.05rem;
        left: 60%;
        margin-top: 1.5rem;
        font-size: 1rem;
        padding: 0.9rem;

        .close {
          top: 7%;
          right: 3%;
          width: 13px;
          height: 13px;
        }
  }

}

@media(max-width: 425px) {
  .content-container {
    flex-direction: column;
    .info-container {
      padding: 2rem 0 1rem 0;
      margin: 0 0 0 4rem;

      .info-three {
        h4 {
          margin: 0 0 0.2rem 0;
        }
        a:last-child {
          margin-left: 6px;
        }

        .social-icon:nth-child(n) {
              margin: 0 1px 0 2px;
        }
      }
    }

  .contactForm {
    width: 80%;
    padding: 0;
    margin: 0 auto;
  }

  }

  .content-container .contactForm .modal {
        left: 45%;
        width: 320px;
        padding: 0.7rem;
        font-size: 0.9rem;

        .close {
          top: 8%;
          right: 2.5%;
          width: 12px;
          height: 12px;
        }
  }
  .content-container .info-container .info-three .social-icon {
    width: 26px;
    height: 26px;
  }
}

@media(max-width:395px) {
  .content-container {
    .info-container {
      margin: 0 0 0 3rem;
      .box {
        h4 {
          font-size: 0.95rem;
        }
        p {
          font-size: 0.95rem;
        }
        img {
          width: 29px;
          height: 29px;
        }
      }
    }
  }
  .content-container .info-container .info-three .social-icon {
    width: 24px;
    height: 24px;
  }
}



</style>